import config from '../config/config.json';

export async function deletePdf(pdf_id, signal) {
    const base = (`${(config.API_URL || '').replace(/\/+$/, '')}/pdfs`);
    const url = `${base}/${encodeURIComponent(pdf_id)}`;

    const res = await fetch(url, {
        method: 'DELETE',
        headers: { Accept: 'application/json' },
        signal,
    });
    if (!res.ok) {
        let detail = '';
        try { detail = await res.text(); } catch { }
        throw new Error(`HTTP ${res.status} ${res.statusText}${detail ? ` — ${detail}` : ''}`);
    }
    const ct = res.headers.get('content-type') || '';
    return ct.includes('application/json') ? res.json() : {};
}



export async function fetchPdfs(signal) {
    const res = await fetch(`${config.API_URL}/pdfs`, { signal });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function uploadPdf(file, signal) {
    const fd = new FormData();
    fd.append("file", file);
    const res = await fetch(`${config.API_URL}/upload-pdf`, { method: "POST", body: fd, signal });
    if (!res.ok) throw new Error(await res.text());
    return res.json(); // {message, id, collection}
}

export async function embedPdf(pdf_id) {
    const res = await fetch(`${config.API_URL}/embed-pdf`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ pdf_id }),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function askQuestion(pdf_id, question) {
    const res = await fetch(`${config.API_URL}/ask`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ pdf_id, question }),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json(); // {answer}
}

export async function fetchChats(pdf_id, signal) {
    const res = await fetch(`${config.API_URL}/chats/${pdf_id}`, { signal });
    if (!res.ok) throw new Error(await res.text());
    return res.json(); // { pdf_id, messages: [{role,text,created_at}, ...] }
}


export async function searchPdfs(query, signal) {
    const res = await fetch(`${config.API_URL}/pdfs?q=${encodeURIComponent(query || '')}`, { signal });
    if (!res.ok) throw new Error(await res.text());
    return res.json(); // [{id, filename}, ...]
}